import { settings } from "./settings";

export const dashboardItemStoreFeatures =
{
    settings
};